
import Slider from "react-slick";
import React from 'react'
export default function HomeBanner() {

  const settings2 = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed:4000,
    speed: 5000,
    pauseOnHover: true,
  };
  return (
    <>
      <div className="banner-section">
        <div className="mainbanner-slider">
          <Slider {...settings2} >
            <div className="mainbanner-col">
              <div className="mainbanner-col-inner">
                <img src="/assets/images/home-banner1.webp" className="img-responsive" alt="banner" width="1920" height="840" fetchPriority="high" decoding="async" />
              </div>
              <div className="banner-content-text">
                <div className="container banner-content">
                  <div className="row align-items-end">
                    <div className="col-lg-7 col-md-12 col-sm-12">
                      <div className="homebanner-text">
                        <div>
                          <img src="/assets/images/trusted-image.webp" alt="Reinvented" className="img-responsive  trusted-image" width="411" height="156" decoding="async" />
                          <h1 className='heading'>Performance Built <span> For Scale</span></h1>
                          <p>Designed for performance that doesn’t pause.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-5  d-none d-md-none">
                      <div className="homebanner-slider"> </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div className="mainbanner-col">
              <div className="mainbanner-col-inner">
                <img src="/assets/images/home-banner2.webp" className="img-responsive" alt="banner" width="1920" height="840" loading="lazy" decoding="async" />
              </div>
              <div className="banner-content-text">
                <div className="container banner-content">
                  <div className="row align-items-end">
                    <div className="col-lg-7 col-md-12 col-sm-12">
                      <div className="homebanner-text">
                        <div>
                          <img src="/assets/images/trusted-image.webp" alt="Reinvented" className="img-responsive  trusted-image" width="411" height="156" loading="lazy" decoding="async" />
                          <div className='heading'>Designed For  <span>Zero Downtime</span></div>
                          <p>Engineered for uninterrupted performance in demanding environments.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-5  d-none d-md-none">
                      <div className="homebanner-slider"> </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mainbanner-col">
              <div className="mainbanner-col-inner">
                <img src="/assets/images/home-banner3.webp" className="img-responsive" alt="banner" width="1920" height="840" loading="lazy" decoding="async" />
              </div>
              <div className="banner-content-text">
                <div className="container banner-content">
                  <div className="row align-items-end">
                    <div className="col-lg-7 col-md-12 col-sm-12">
                      <div className="homebanner-text">
                        <div>
                          <img src="/assets/images/trusted-image.webp" alt="Reinvented" className="img-responsive  trusted-image" width="411" height="156" loading="lazy" decoding="async" />
                          <div className='heading'>Rethinking Laundry  <span>Operations</span></div>
                          <p>End-to-end solutions that streamline workflows and improve output.</p>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-5  d-none d-md-none">
                      <div className="homebanner-slider"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </>
  )
}
